module.exports = __webpack_public_path__ + "img/BET365.RU.ba845288.svg";